import React, { useState, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  Calendar,
  Clock,
  User,
  Globe,
  Search,
  MapPin,
  Video,
  Award,
  ChevronDown,
} from "lucide-react";

const AGENDA_DAYS = [
  {
    dateStr: "Viernes, 06 de noviembre de 2026",
    dateLabel: "Viernes 06 Nov",
    phase: "Fase Presencial (Aula Magna - Campus UTPL)",
    isVirtual: false,
    events: [
      {
        id: "p1-1",
        time: "07:30 - 08:00",
        title: "Registro de participantes",
        speaker: "Comité Organizador",
        country: "Ecuador",
      },
      {
        id: "p1-2",
        time: "08:00 - 08:15",
        title: "Inauguración del evento",
        speaker: "Autoridades UTPL",
        country: "Ecuador",
      },
      {
        id: "p1-3",
        time: "08:15 - 09:00",
        title: "Adaptación neonatal y evaluación del recién nacido",
        speaker: "Dr. Diego Ríos Jaramillo",
        country: "Ecuador",
      },
      {
        id: "p1-4",
        time: "09:00 - 10:00",
        title: "Cuidados centrados en el desarrollo en UCI neonatal",
        speaker: "Mgtr. Isdery Natali Moreno Samaniego",
        country: "Ecuador",
      },
      {
        id: "p1-5",
        time: "10:00 - 13:00",
        title: "Taller 1: Evaluación integral del prematuro",
        speaker: "Mgtr. María del Mar Marulanda Grizales",
        country: "Colombia",
      },
      {
        id: "p1-6",
        time: "13:00 - 15:00",
        title: "Receso / Almuerzo",
        speaker: null,
        country: null,
      },

        {
        id: "p1-7",
        time: "15:00 - 16:00",
        title:
          "Actualizaciones en fisioterapia pediátrica acorde a los avances en neurociencia y ciencia del movimiento",
        speaker: "PhD. Lourdes Macías Merlo",
        country: "España",
      },
      
      {
        id: "p1-8",
        time: "16:00 - 17:00",
        title: "Manejo integral en fisioterapia en el recién nacido de riesgo",
        speaker: "Mgtr. Sara León",
        country: "Ecuador",
      },
      {
        id: "p1-9",
        time: "17:00 - 18:00",
        title: "Análisis de caso clínico",
        speaker: "Ponentes de todas las áreas",
        country: "Ecuador / Colombia",
      },
    ],
  },
  {
    dateStr: "Sábado, 7 de noviembre de 2026",
    dateLabel: "Sábado 07 Nov",
    phase: "Fase Presencial (Centro de Convenciones - Campus UTPL)",
    isVirtual: false,
    events: [
      {
        id: "p2-1",
        time: "08:00 - 10:00",
        title:
          "Impacto del sistema vestibular y propioceptivo en el desarrollo integral del niño",
        speaker: "Mgtr. María del Mar Marulanda Grizales",
        country: "Colombia",
      },
      {
        id: "p2-2",
        time: "10:00 - 11:00",
        title: "Tecnología y realidad virtual en rehabilitación pediátrica",
        speaker: "Mgtr. Samuel Pérez del Camino",
        country: "España",
      },
       {
        id: "p2-3",
        time: "11:00 - 12:00",
        title: "Prematuridad y factores de riesgo en el neurodesarrollo",
        speaker: "Mgtr. Anderson Stalin Medina Aguirre",
        country: "Ecuador",
      },
    
      {
        id: "p2-4",
        time: "12:00 - 13:00",
        title:
          "Avances actuales en rehabilitación pediátrica de enfermedades neuromusculares",
        speaker: "PhD. Joaquín Fagoaga Mata",
        country: "España",
      },
      {
        id: "p2-5",
        time: "13:00 - 15:00",
        title: "Receso / Almuerzo",
        speaker: null,
        country: null,
      },
      {
        id: "p2-6",
        time: "15:00 - 17:00",
        title: "Taller 2: Impacto de la ATM en el control postural del niño",
        speaker: "Mgtr. María del Mar Marulanda Grizales",
        country: "Colombia",
      },
      {
        id: "p2-7",
        time: "17:00 - 18:00",
        title:
          'Actividad de Gamificación: Concurso "¿Quién quiere ser fisioterapeuta?"',
        speaker: "Organiza: FEUE - UTPL Fisioterapia",
        country: "Ecuador",
      },
    ],
  },
  {
    dateStr: "Lunes, 9 de noviembre de 2026",
    dateLabel: "Lunes 09 Nov",
    phase: "Fase Virtual (Síncrona vía Zoom)",
    isVirtual: true,
    events: [
      {
        id: "v-1",
        time: "19:00 - 20:00",
        title:
          "Inmadurez neonatal: Intervención fonoaudiológica en la alimentación del prematuro",
        speaker: "Mgtr. Anna Cristina Loarte",
        country: "Ecuador",
      },
    ],
  },
  {
    dateStr: "Martes, 10 de noviembre de 2026",
    dateLabel: "Martes 10 Nov",
    phase: "Fase Virtual (Síncrona vía Zoom)",
    isVirtual: true,
    events: [
      {
        id: "v-2",
        time: "19:00 - 20:00",
        title: "Integración sensorial en pediatría",
        speaker: "Mgtr. Soledad Monserrath Castillo Sarango",
        country: "Ecuador",
      },
    ],
  },
  {
    dateStr: "Miércoles, 11 de noviembre de 2026",
    dateLabel: "Miércoles 11 Nov",
    phase: "Fase Virtual (Síncrona vía Zoom)",
    isVirtual: true,
    events: [
      {
        id: "v-3",
        time: "18:00 - 19:00",
        title:
          "La evaluación temprana por imágenes de la craneosinostosis en su manejo integral",
        speaker: "Dra. Karen Sarango",
        country: "Ecuador",
      },
      {
        id: "v-4",
        time: "19:00 - 20:00",
        title: "Terapia manual en craneosinostosis",
        speaker: "Mgtr. Edissa María Bravo Brito",
        country: "Ecuador",
      },
    ],
  },
  {
    dateStr: "Jueves, 12 de noviembre de 2026",
    dateLabel: "Jueves 12 Nov",
    phase: "Fase Virtual (Síncrona vía Zoom)",
    isVirtual: true,
    events: [
      {
        id: "v-5",
        time: "18:00 - 20:00",
        title:
          "Modelo de Atención Centrado en la Familia: Evaluación funcional y objetivos terapéuticos en pediatría",
        speaker: "Mgtr. Valeria Bayliss",
        country: "México",
      },
    ],
  },
  {
    dateStr: "Viernes, 13 de noviembre de 2026",
    dateLabel: "Viernes 13 Nov",
    phase: "Fase Virtual (Síncrona vía Zoom)",
    isVirtual: true,
    events: [
      {
        id: "v-6",
        time: "18:00 - 19:00",
        title:
          "Microbiota intestinal durante la lactancia y alimentación complementaria",
        speaker: "Mgtr. Paula Calderón",
        country: "Ecuador",
      },
    ],
  },
  {
    dateStr: "Sábado, 14 de noviembre de 2026",
    dateLabel: "Sábado 14 Nov",
    phase: "Fase Virtual (Síncrona vía Zoom)",
    isVirtual: true,
    events: [
      {
        id: "v-7",
        time: "10:00 - 11:00",
        title: "Neurociencias del control postural en el paciente pediátrico",
        speaker: "PhD. Ismael Sanz",
        country: "España",
      },
      {
        id: "v-8",
        time: "11:00 - 12:00",
        title:
          "Sentidos y movimiento: Abordaje sensoriomotor en rehabilitación pediátrica",
        speaker: "Lic. Silvia Uzcátegui",
        country: "Ecuador",
      },
      {
        id: "v-9",
        time: "12:00",
        title: "Cierre del evento",
        speaker: "Comité Organizador UTPL",
        country: "Ecuador",
      },
    ],
  },
];

const getCountryFlag = (country) => {
  if (!country) return "🌐";
  if (country.includes("Ecuador") && country.includes("Colombia"))
    return "🇪🇨 🇨🇴";
  if (country.includes("Ecuador")) return "🇪🇨";
  if (country.includes("Colombia")) return "🇨🇴";
  if (country.includes("España")) return "🇪🇸";
  if (country.includes("México")) return "🇲🇽";
  return "🌐";
};

export default function Agenda() {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDayFilter, setSelectedDayFilter] = useState("all");

  // Filter the agenda data keeping the vertical date hierarchy
  const filteredSchedule = useMemo(() => {
    return AGENDA_DAYS.map((dayGroup) => {
      // Day filter
      if (
        selectedDayFilter !== "all" &&
        dayGroup.dateLabel !== selectedDayFilter
      ) {
        return null;
      }

      // Search query filter across title, speaker, country, time
      const matchingEvents = dayGroup.events.filter((event) => {
        if (!searchTerm.trim()) return true;
        const q = searchTerm.toLowerCase();
        const matchesTitle = event.title.toLowerCase().includes(q);
        const matchesSpeaker =
          event.speaker?.toLowerCase().includes(q) || false;
        const matchesCountry =
          event.country?.toLowerCase().includes(q) || false;
        const matchesTime = event.time.toLowerCase().includes(q);
        return matchesTitle || matchesSpeaker || matchesCountry || matchesTime;
      });

      if (matchingEvents.length === 0) return null;

      return {
        ...dayGroup,
        events: matchingEvents,
      };
    }).filter(Boolean);
  }, [searchTerm, selectedDayFilter]);

  const totalActivitiesCount = useMemo(() => {
    return filteredSchedule.reduce((acc, curr) => acc + curr.events.length, 0);
  }, [filteredSchedule]);

  return (
    <div className=" py-10">
     
 
     <h2 className="text-center pt-6 pt-24 mt-12">Agenda del evento</h2>

    
      {/* Control bar: Búsqueda y selector de días */}
      <main className="max-w-6xl mx-auto px-4 sm:px-6 mt-6">
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-4 mb-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            {/* Search Input */}
            <div className="relative w-full sm:flex-1">
              <Search className="w-4 h-4 text-slate-400 absolute left-3.5 top-1/2 -translate-y-1/2" />
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Buscar por título, ponente, país u hora..."
                className="w-full pl-10 pr-4 py-2 bg-slate-50 border border-slate-200 rounded-xl text-xs sm:text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-[#004270] focus:border-transparent transition-all"
              />
              {searchTerm && (
                <button
                  onClick={() => setSearchTerm("")}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-slate-400 hover:text-slate-600 font-semibold"
                >
                  ✕
                </button>
              )}
            </div>

            {/* Quick day dropdown / filter */}
            <div className="w-full sm:w-auto flex items-center justify-between sm:justify-start gap-2">
              <span className="text-xs font-semibold text-slate-500 whitespace-nowrap">
                {totalActivitiesCount} actividades
              </span>
              <select
                value={selectedDayFilter}
                onChange={(e) => setSelectedDayFilter(e.target.value)}
                className="text-xs bg-slate-50 border border-slate-200 rounded-xl px-3 py-2 text-slate-700 font-medium focus:outline-none focus:ring-2 focus:ring-[#004270]"
              >
                <option value="all">Todas las fechas</option>
                {AGENDA_DAYS.map((d) => (
                  <option key={d.dateLabel} value={d.dateLabel}>
                    {d.dateLabel}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {}
        <div className="relative">
          {/* Vertical track line running through the dates */}
          <div className="hidden sm:block absolute left-[21px] top-6 bottom-6 w-0.5 bg-slate-200" />

          <div className="space-y-10">
            {filteredSchedule.length === 0 ? (
              <div className="bg-white rounded-2xl p-10 text-center border border-slate-200">
                <Calendar className="w-10 h-10 text-slate-300 mx-auto mb-2" />
                <p className="text-sm font-semibold text-slate-700">
                  No se encontraron actividades
                </p>
                <p className="text-xs text-slate-400 mt-1">
                  Prueba con otro término de búsqueda o selecciona todas las
                  fechas.
                </p>
                <button
                  onClick={() => {
                    setSearchTerm("");
                    setSelectedDayFilter("all");
                  }}
                  className="mt-3 px-3 py-1.5 bg-[#004270] text-white rounded-lg text-xs font-semibold"
                >
                  Restablecer
                </button>
              </div>
            ) : (
              filteredSchedule.map((dayGroup, dayIndex) => (
                <div key={dayGroup.dateStr} className="relative">
                  {}
                  {/* Sticky Date Header with Badge */}
                  <div className="flex items-center gap-3 mb-4 sticky top-3 z-20">
                    {/* Circle Node Icon */}
                    <div className="w-11 h-11 rounded-full bg-[#004270] text-[#febe10] border-4 border-slate-100 flex items-center justify-center shadow-md flex-shrink-0">
                      <Calendar className="w-5 h-5" />
                    </div>

                    {/* Date Pill & Modality Tag */}
                    <div className="flex flex-wrap items-center gap-2 bg-white/95 backdrop-blur-md px-4 py-2 rounded-2xl border border-slate-200 shadow-sm flex-1">
                      <h2 className="text-sm sm:text-base font-extrabold text-[#004270]">
                        {dayGroup.dateStr}
                      </h2>
                      <span
                        className={`inline-flex items-center gap-1 text-[11px] font-semibold px-2.5 py-0.5 rounded-full ${
                          dayGroup.isVirtual
                            ? "bg-indigo-50 text-indigo-700 border border-indigo-200"
                            : "bg-emerald-50 text-emerald-700 border border-emerald-200"
                        }`}
                      >
                        {dayGroup.isVirtual ? (
                          <>
                            <Video className="w-3 h-3" />
                            {dayGroup.phase}
                          </>
                        ) : (
                          <>
                            <MapPin className="w-3 h-3" />
                            {dayGroup.phase}
                          </>
                        )}
                      </span>
                    </div>
                  </div>

                  {/* Vertical Items List */}
                  <div className="sm:pl-14 space-y-3">
                    {dayGroup.events.map((event, eventIdx) => {
                      const isRecess = event.title
                        .toLowerCase()
                        .includes("receso");

                      return (
                        <motion.article
                          key={event.id}
                          initial={{ opacity: 0, y: 8 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.2, delay: eventIdx * 0.02 }}
                          className={`rounded-xl border transition-all ${
                            isRecess
                              ? "bg-slate-50/70 border-dashed border-slate-300 py-2.5 px-4"
                              : "bg-white border-slate-200/90 hover:border-[#004270]/40 hover:shadow-sm p-4"
                          }`}
                        >
                          <div className="flex flex-col sm:flex-row sm:items-start gap-3 sm:gap-4">
                            {/* 1. HORA (a la izquierda) */}
                            <div className="flex-shrink-0 sm:w-36">
                              <span className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-[#004270]/5 border border-[#004270]/20 text-[#004270] font-bold text-xs sm:text-xs whitespace-nowrap">
                                <Clock className="w-3.5 h-3.5 text-[#febe10] flex-shrink-0" />
                                {event.time}
                              </span>
                            </div>

                            {/* 2. DETALLES: Título, Ponente, País */}
                            <div className="flex-1 min-w-0">
                              {/* Título */}
                              <h3
                                className={`font-bold leading-snug ${
                                  isRecess
                                    ? "text-xs text-slate-500 italic"
                                    : "text-sm sm:text-base text-slate-900"
                                }`}
                              >
                                {event.title}
                              </h3>

                              {/* Ponente & País (si aplica) */}
                              {(event.speaker || event.country) && (
                                <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-slate-600">
                                  {event.speaker && (
                                    <div className="flex items-center gap-1.5 font-medium text-slate-700">
                                      <User className="w-3.5 h-3.5 text-[#004270] flex-shrink-0" />
                                      <span className="font-semibold">
                                        {event.speaker}
                                      </span>
                                    </div>
                                  )}

                                  {event.country && (
                                    <div className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-slate-100 border border-slate-200 text-slate-600 text-[11px] font-medium">
                                      <span>
                                        {getCountryFlag(event.country)}
                                      </span>
                                      <span>{event.country}</span>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </motion.article>
                      );
                    })}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
